export default __webpack_public_path__ + "static/media/julian_jedi.e1827973.svg";